/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import LoadingOverlay from "../../../components/Ui/LoadingOverlay";
import SearchInput from "../../../components/Ui/Search";
import Pagination from "../../../components/Ui/Paging";
import { calculatePage } from "../../../utils/paging";

import { useLocation, useNavigate } from "react-router-dom";
import { formatDateToCustomString } from "../../../utils/utils";
import Create from "./Create";
import { IconPlus } from "../../../components/Ui/Icon";
import { adminGetEmailMkt } from "../../../services/email";

const ListEmailMKT = () => {
  const [data, setData] = useState([]);
  const [selectData, setSelectData] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(new Date());

  const [isOpenCreate, setIsOpenCreate] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [paging, setPaging] = useState({
    page: parseInt(searchParams.get("page")) || 1,
    limit: parseInt(searchParams.get("limit")) || 10,
    sortBy: searchParams.get("sortBy") || "createdAt",
    sortType: searchParams.get("sortType") || "DESC",
    search: searchParams.get("search") || "",
    total: 0,
    totalPages: 0,
  });

  const setQueryParams = (queryParams) => {
    const searchParams = new URLSearchParams();

    Object.keys(queryParams).forEach((key) => {
      searchParams.set(key, queryParams[key]);
    });

    navigate({ search: searchParams.toString() });
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const dataSubs = await adminGetEmailMkt(paging);
      setTimeout(() => {
        setData(dataSubs?.data?.data);
        setPaging((prev) => ({
          ...prev,
          total: dataSubs?.data?.total,
          totalPages: calculatePage(dataSubs?.data?.total, prev.limit),
        }));
      });

      setLoading(false);
    };
    fetchData();
    setTimeout(() => {
      setQueryParams(paging);
    });
  }, [
    paging.page,
    paging.limit,
    paging.sortBy,
    paging.sortType,
    paging.search,
    refresh,
  ]);

  const handlePageChange = (page) => {
    setPaging((prev) => ({
      ...prev,
      page,
    }));
  };

  const onSearch = (search) => {
    setPaging((prev) => ({
      ...prev,
      search,
    }));
  };
  const dataSection = useMemo(() => {
    return (
      <table className="w-full text-sm text-left rtl:text-right text-gray-500">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3">
              STT
            </th>
            <th scope="col" className="px-6 py-3">
              Title
            </th>
            <th scope="col" className="px-6 py-3">
              Type
            </th>
            <th scope="col" className="px-6 py-3">
              Sent At
            </th>
            <th scope="col" className="px-6 py-3"></th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <>
              <tr key={index} className="bg-white border-b ">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                >
                  {index + 1}
                </th>
                <td className="px-6 py-4">{item?.title}</td>
                <td className="px-6 py-4">{item?.type}</td>
                <td>{formatDateToCustomString(item.createdAt)}</td>
                <td>
                  <button
                    onClick={(e) => {
                      setSelectData(item);
                      setIsOpenCreate(true);
                    }}
                    className="text-white bg-slate-400 hover:bg-slate-500 rounded focus:ring-4 focus:ring-blue-300 font-medium text-sm px-2.5 py-1 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    View
                  </button>
                </td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    );
  }, [data]);

  const pagine = useMemo(() => {
    if (!paging.totalPages || paging.total <= paging.limit) return <></>;
    return (
      <Pagination
        totalPages={paging.totalPages}
        currentPage={paging.page}
        onPageChange={handlePageChange}
      />
    );
  }, [paging.page, paging.totalPages]);
  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
      <div className="flex w-full justify-between items-center p-3 flex-wrap md:flex-nowrap">
        <h2 className="font-semibold text-3xl text-left rtl:text-right text-gray-900">
          Emails
        </h2>
        <div className="inline-flex items-center gap-2">
          <a
            href="#create"
            onClick={(e) => setIsOpenCreate(true)}
            type="button"
            className="flex items-center p-2 text-sm font-medium h-full text-white bg-blue-700 rounded-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300"
          >
            <IconPlus />
            <span> Create</span>
          </a>
          <SearchInput className="md:mr-28" onSubmitSearch={onSearch} />
        </div>
      </div>
      {dataSection}
      {pagine}
      {loading && <LoadingOverlay />}

      {isOpenCreate && (
        <Create
          data={selectData}
          onSubmited={(e) => setRefresh(new Date())}
          togglePopup={() => {
            setSelectData(null);
            setIsOpenCreate(false);
          }}
        />
      )}
    </div>
  );
};

export default ListEmailMKT;
